import React, { useState } from "react";
import TableResizable from "components/antdCustom/TableResizable";
import { getAttendanceColumns } from "./ColumnAttendance";

const TableAttendance = ({ data }) => {
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });

  return (
    <TableResizable
      scroll={{ x: "100%" }}
      rowKey="id"
      columns={getAttendanceColumns(pagination)}
      dataSource={data}
      pagination={{
        ...pagination,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50", "100"],
        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
        onChange: (page, pageSize) => setPagination({ current: page, pageSize }),
      }}
    />
  );
};

export default TableAttendance;